(ns web3.routers.pro-handlers
  (:require [web3.screens.pro.flow :as flow]
            [web3.screens.pro.dashboard :as dashboard]))

(def root {:pro/dashboard dashboard/dashboard})

(def form-modal {:pro/start flow/start
                 :pro/contact flow/contact
                 :pro/address flow/address
                 :pro/pictures flow/pictures
                 :pro/share-link flow/share-link
                 :pro/review flow/review
                 :pro/premium-offer flow/premium-offer
                 :pro/business-profile flow/business-profile})

(def drawer {:pro/detail flow/detail
             :pro/offer flow/offer})